import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";
import Index from "./pages/Index";
import Missao from "./pages/Missao";
import MissoesCaatinga from "./pages/MissoesCaatinga";
import Teologia from "./pages/Teologia";
import SobreInstituto from "./pages/SobreInstituto";
import Contato from "./pages/Contato";
import Professores from "./pages/Professores";
import ProjetoAscender from "./pages/ProjetoAscender";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAgents from "./pages/AdminAgents";
import AdminAgentEditor from "./pages/AdminAgentEditor";
import AdminCreate from "./pages/AdminCreate";
import AdminLibrary from "./pages/AdminLibrary";
import AdminPostEditor from "./pages/AdminPostEditor";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const PublicLayout = () => (
  <div className="flex min-h-screen flex-col bg-background">
    <SiteHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Index />} />
            <Route path="/missao" element={<Missao />} />
            <Route path="/missoes-caatinga" element={<MissoesCaatinga />} />
            <Route path="/projeto-ascender" element={<ProjetoAscender />} />
            <Route path="/teologia" element={<Teologia />} />
            <Route path="/sobre" element={<SobreInstituto />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/professores" element={<Professores />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Route>

          {/* Admin login (standalone) */}
          <Route path="/admin" element={<Admin />} />

          {/* Admin routes with sidebar */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="agents" element={<AdminAgents />} />
            <Route path="agents/new" element={<AdminAgentEditor />} />
            <Route path="agents/:id/edit" element={<AdminAgentEditor />} />
            <Route path="create" element={<AdminCreate />} />
            <Route path="library" element={<AdminLibrary />} />
            <Route path="posts/new" element={<AdminPostEditor />} />
            <Route path="posts/:id/edit" element={<AdminPostEditor />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
